/**
 * Organization anchor (P2 Build J — the Orbit transition off string-grouping).
 *
 * When the stakeholder route carries a REAL organization id (a UUID from the
 * organizations table), StakeholderDetails resolves the org and its primary member
 * once, then renders the existing child components against the legacy-shaped anchor
 * id (`org-<clientid>`) they already understand — the prefer-new, fall-back-to-old
 * 0008 resolver shape, applied to the UI.
 *
 * This context carries the REAL org alongside, so the pieces that must write to the
 * org record itself (rename in EditStakeholderModal, link-contact in
 * LinkExistingContactModal) target the organizations API instead of the legacy
 * PUT-the-whole-client path. Null everywhere outside a real-org detail view.
 */

import { createContext, useContext } from 'react';
import type { Organization } from '@frontend/AppSettings/services/OrganizationService';

export interface OrganizationAnchor {
  organization: Organization;
  /** `org-<clientid>` of the primary member — what the legacy children render from. */
  anchorId: string | null;
}

export const OrganizationAnchorContext = createContext<OrganizationAnchor | null>(null);

export const useOrganizationAnchor = (): OrganizationAnchor | null =>
  useContext(OrganizationAnchorContext);
